import { CompositeSegment } from '@goldcast/player-config/src/types/RemotionPlayerConfigTypes/Segment/CompositeSegment';
import { LayoutType } from '@goldcast/player-config/src/types/asset-types';
import createStore from '@/stores/store';

/**
 * Drives the clips sidebar's "select clips to add to the timeline" mode.
 *
 * The sidebar list is a single shared instance mounted far from the timeline, so the insertion
 * handler cannot be passed down as a prop. It is parked here instead, together with the gap the
 * user clicked, so the panel stays decoupled from the timeline while inserts still land at the
 * right anchor rather than at a guessed position.
 */
type AddClipToTimelineState = {
  isSelecting: boolean;
  /** Set when the request came from a timeline gap; null while no request is active. */
  onInsert: ((segments: CompositeSegment[]) => void) | null;
  /**
   * Layout of the clip being edited. The picker needs it to warn when an imported clip's layout
   * will be rewritten, and the sidebar has no access to the timeline's ClipsContext.
   */
  targetLayout: LayoutType | null;
  /** Id of the clip being edited — the picker filters it out to prevent self-insertion. */
  sourceClipId: string | null;
};

export const addClipToTimelineStore = createStore<AddClipToTimelineState>({
  isSelecting: false,
  onInsert: null,
  targetLayout: null,
  sourceClipId: null
});

export function startAddClipToTimeline({
  onInsert,
  targetLayout,
  sourceClipId
}: {
  onInsert: (segments: CompositeSegment[]) => void;
  targetLayout: LayoutType;
  sourceClipId: string;
}) {
  addClipToTimelineStore.set(() => ({ isSelecting: true, onInsert, targetLayout, sourceClipId }));
}

export function stopAddClipToTimeline() {
  addClipToTimelineStore.set(() => ({ isSelecting: false, onInsert: null, targetLayout: null, sourceClipId: null }));
}
